import { render, staticRenderFns } from "./addCourseDialog.vue?vue&type=template&id=579fcca1&scoped=true&"
import script from "./addCourseDialog.vue?vue&type=script&lang=js&"
export * from "./addCourseDialog.vue?vue&type=script&lang=js&"
import style0 from "./addCourseDialog.vue?vue&type=style&index=0&id=579fcca1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579fcca1",
  null
  
)

export default component.exports